import type { ReactNode } from 'react'
import { cn } from '~/shadcn/lib/utils'
import { Progress } from '~/shadcn/ui/progress'

type Props = {
  valueWidth?: number
  progress?: number
  value: ReactNode
}

export function ProgressLine({
  valueWidth = 32,
  value,
  progress = 100,
}: Props) {
  return (
    <div
      className={cn('flex flex-row w-full items-center flex-grow', 'lg:hidden')}
      style={{ flexGrow: 1 }}>
      <div style={{ width: valueWidth }} translate="no">
        {value}
      </div>
      <div className="flex-1">
        <Progress value={progress} />
      </div>
    </div>
  )
}
